export default {
    mainPopupList: [],
};